import React from 'react';
import { colors, spacing, shadows } from '../../../design/tokens';

export const Features: React.FC = () => {
  const featureList = [
    {
      icon: '🛡️',
      title: 'Security Scan',
      desc: 'Automated deep scans based on OWASP Top 10 to identify vulnerabilities and security gaps in real-time.'
    },
    {
      icon: '⚡',
      title: 'Automated Fixes',
      desc: 'Exibrain doesn’t just find bugs—it writes context-aware, production-ready fixes that follow your coding style.'
    },
    {
      icon: '🔄',
      title: 'Validation Loop',
      desc: 'Every fix is automatically built and tested against your existing suite to ensure zero regressions.'
    },
    {
      icon: '📊',
      title: 'Usage Monitoring',
      desc: 'Track token consumption and engineering time saved with automated remediation metrics.'
    },
    {
      icon: '🧩',
      title: 'Seamless Integration',
      desc: 'Plugs directly into your existing development workflow with support for multiple roles and companies.'
    },
    {
      icon: '🚀',
      title: 'Enterprise Ready',
      desc: 'Role-based access control, company management, and budget tracking for teams and organizations.'
    }
  ];

  return (
    <section id="features" style={{ padding: `${spacing.xxl} ${spacing.xl}`, backgroundColor: colors.neutral[100] }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: spacing.xxl }}>
          <h2 style={{ fontSize: '40px', fontWeight: 800, color: colors.neutral[1000], marginBottom: spacing.md, letterSpacing: '-0.02em' }}>
            Enterprise-Grade Code Security
          </h2>
          <p style={{ fontSize: '18px', color: colors.neutral[600], maxWidth: '700px', margin: '0 auto' }}>
            Exibrain simplifies the complexity of security, offering a complete solution from detection to autonomous remediation.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: spacing.lg }}>
          {featureList.map((f, i) => (
            <div key={i} style={{ 
              padding: spacing.xl, 
              borderRadius: '12px', 
              border: `1px solid ${colors.neutral[200]}`,
              transition: 'all 0.2s ease',
              backgroundColor: 'white',
              cursor: 'default'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(0, 0, 0, 0.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            >
              <div style={{ fontSize: '28px', marginBottom: spacing.md, opacity: 0.9 }}>{f.icon}</div>
              <h3 style={{ fontSize: '20px', fontWeight: 700, marginBottom: spacing.sm, color: colors.neutral[1000] }}>{f.title}</h3>
              <p style={{ color: colors.neutral[600], lineHeight: 1.6, fontSize: '15px' }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
